/**
 * Public API for admin account recovery (no auth token).
 * Used when admin enters recovery ID and PIN on login screen.
 */

import { API_BASE_URL } from '../config/apiConfig';

const RECOVERY_API_URL = `${API_BASE_URL}/auth/recovery`;

export interface RecoveryQuestionsResponse {
  success: boolean;
  question1?: string;
  question2?: string;
  question3?: string;
  message?: string;
}

export interface RecoveryResetPasswordResponse {
  success: boolean;
  message?: string;
}

export async function getRecoveryQuestions(
  recoveryId: string,
  recoveryPin: string
): Promise<RecoveryQuestionsResponse> {
  const res = await fetch(`${RECOVERY_API_URL}/questions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ recoveryId: recoveryId.trim(), recoveryPin }),
  });
  return res.json();
}

export async function resetPasswordWithRecovery(
  recoveryId: string,
  recoveryPin: string,
  answer1: string,
  answer2: string,
  answer3: string,
  newPassword: string
): Promise<RecoveryResetPasswordResponse> {
  const res = await fetch(`${RECOVERY_API_URL}/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      recoveryId: recoveryId.trim(),
      recoveryPin,
      answer1: answer1.trim(),
      answer2: answer2.trim(),
      answer3: answer3.trim(),
      newPassword,
    }),
  });
  return res.json();
}
